export default {
    unpaid: {
        value: 1,
        label: 'Unpaid',
        key: 'unpaid'
    },
    initiated: {
        value: 2,
        label: 'Initiated',
        key: 'initiated'
    },
    paid: {
        value: 3,
        label: 'Paid',
        key: 'paid'
    },
    payment_failed: {
        value: 4,
        label: 'Payment Failed',
        key: 'payment_failed'
    },
    refunded: {
        value: 5,
        label: 'Refunded',
        key: 'refunded'
    }
};
